<template>
  <b-row>
    <b-col cols="12" class="client-selector">
      <multiselect
        :class="{ 'is-invalid': errors.has(name) }"
        v-validate="{ required: isRequired }"
        :name="name"
        :value="valueOwned"
        :options="employers"
        :disabled="disabled"
        :multiple="multiple"
        selectLabel=""
        :deselectLabel="deselectLabel"
        placeholder="- Select Client -"
        label="name"
        track-by="id"
        :close-on-select="!multiple"
        :allow-empty="allowEmpty"
        @input="handleValueChanged"
      ></multiselect>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";
import { ACTION_GET_EMPLOYER_LIST } from "@/store/modules/employers/constants";

export default {
  name: "c-client-selector",
  components: {
    Multiselect
  },
  props: {
    value: null,
    name: {
      type: String,
      default: "client-selector"
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    isFullObject: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    selectedClientPanelId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      limit: 0,
      clientOptions: [],
      employers: []
    };
  },
  computed: {
    valueOwned: {
      get: function() {
        if (!this.value || (this.value && this.value.length === 0)) {
          return this.multiple ? [] : "";
        }
        if (this.multiple && typeof this.value === "object") {
          const res = this.employers
            .filter(e =>
              this.value.some(v =>
                typeof v === "string" ? e.id === v : e.id === v.id
              )
            )
            .map(e => {
              return {
                id: e.id,
                name: e.name
              };
            });
          // Set the default selected based on a list of string id
          if (typeof this.value[0] === "string" && res.length > 0) {
            this.$emit("input", res);
          }

          return res;
        }

        if (!this.multiple) {
          if (typeof this.value === "string") {
            return this.employers.filter(e => e.id === this.value);
          } else if (typeof this.value === "object") {
            return this.employers.filter(e => e.id === this.value.id);
          }
        }
        return this.value;
      }
    },
    deselectLabel() {
      return this.allowEmpty ? "Deselected" : "";
    }
  },
  methods: {
    handleValueChanged(value) {
      this.$emit("input", value);
    },
    getEmployerData(resp) {
      if (!resp.data) {
        return [];
      }

      if (this.isFullObject) {
        return resp.data;
      }

      return resp.data.map(e => {
        return {
          id: e.id,
          name: e.name
        };
      });
    },
    ...mapActions({
      actionGetAllEmployers: ACTION_GET_EMPLOYER_LIST
    })
  },
  beforeMount() {
    const payload = {
      params: {
        limit: this.limit,
        filter: "id;name;enable_termination_by_omission"
      }
    };
    if (this.selectedClientPanelId) {
      payload.params.selected_client_panel_id = this.selectedClientPanelId;
    }
    this.actionGetAllEmployers(payload).then(resp => {
      this.employers = this.getEmployerData(resp);
    });
  }
};
</script>
<style scoped lang="scss">
  .client-selector {
    z-index: 99;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Clients/ClientSelector.vue